module.exports = __webpack_public_path__ + "img/code-error.4d49f07e.png";